import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { ProgressTitle, ProgressCard, ProgressStepContainer } from './components';
import { ApiConstant } from '../../../../constants';

const TOTAL_STEPS = 4;
const steps = {
  PROFILE_COMPLETED: 1,
  WORK_EXP_COMPLETED: 2,
  CERTIFIED_ONE: 3,
  CERTIFIED_TWO: 4
};

const Endpoint = ApiConstant.BASE_URL + 'challenge/';
const ProgressBar = (props) => {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  }

  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);

  const setCurrentProgress = (result) => {
    let currentStep = 0;
    if (result.profileCompleted) currentStep += 1;
    if (!props.skipASA) {
      if (currentStep === steps.PROFILE_COMPLETED && result.workExpCompleted) currentStep += 1;
      if (currentStep === steps.WORK_EXP_COMPLETED && result.certifiedOne) currentStep += 1;
      if (currentStep === steps.CERTIFIED_ONE && result.certifiedAll) currentStep += 1;
      const percentProgress = Math.ceil((currentStep / TOTAL_STEPS) * 100);
      setProgress(percentProgress);
    } else {
      if (currentStep === steps.WORK_EXP_COMPLETED - 1 && result.certifiedOne) currentStep += 1;
      if (currentStep === steps.CERTIFIED_ONE - 1 && result.certifiedAll) currentStep += 1;
      const percentProgress = Math.ceil((currentStep / (TOTAL_STEPS - 1)) * 100);
      setProgress(percentProgress);
    }
    setCurrent(currentStep);
    setLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const body = {
        action: 'CHECK_MCQ_PROGRESS'
      };
      const response = await axios.post(Endpoint, body);
      const data = response.data;
      if (data.success) {
        setCurrentProgress(data.result);
      } else {
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [props.refreshBar]);

  return (
    <ProgressCard loading={loading}>
      <ProgressTitle
        progress={progress}
      />
      <ProgressStepContainer current={current} passRequire={props.passRequire} allRequire={props.allRequire} isProgrammerRole={props.isProgrammerRole} skipASA={props.skipASA}/>
    </ProgressCard>
  );
};

ProgressBar.propTypes = {
  refreshBar: PropTypes.bool,
  isProgrammerRole: PropTypes.bool,
  passRequire: PropTypes.number,
  allRequire: PropTypes.bool,
  skipASA: PropTypes.bool
};

export default ProgressBar;
